import { connect, ConnectedProps } from 'react-redux'
import CustomError from '../../../../../../../baseComponents/CustomError'
import { ModalLittle } from '../../../../../../../baseComponents/Modal'
import { LittleModalCreateEditChildrenFirst } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { checkIfCanCreateQuote } from '../../../../../../../utils/globals/order/order'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../../../../utils/reducers/company/workingCenters'
import { getSelectedWorkingCenter, getUserPermissions } from '../../../../../../../utils/reducers/getters'
import { SupplierPayload } from '../../../../../../../utils/reducers/products/suppliers'
import { BuyOrderModelTypeExtended } from './types'
import useCreateBuy from '../../../../../../../utils/hooks/buys/orders/useCreateBuy'
import { CustomerPayload } from '../../../../../../../utils/reducers/customers/customer'
import { BillingGroupPayload } from '../../../../../../../utils/reducers/company/billingGroups'
import SearchbarBuySupplierDecider from '../../../../../../../specificComponents/buys/SearchBuySupplierDecider'
import locations from '../../../../../../../utils/globals/locations'

interface ModalCreateBuyOrderProps extends ModalEditComponentProps {}

const ModalCreateBuyOrder: React.FC<ModalCreateBuyOrderProps> = ({ setOpened, ...rest }) => {
    const { t } = useTwinTranslation()
    const userPermissionsSupplier = getUserPermissions('supplier.main')
    if (!permissionCheck(userPermissionsSupplier, 'read')) {
        return <ModalLittle opened={true} setOpened={setOpened}>
            <h2 className='mb-25'>
                <TwinTrans transKey='newBuyOrder'>Nuevo pedido</TwinTrans>
            </h2>
            <CustomError textError={t('noPermissionsToSeeSuppliers', 'No tienes permisos para ver los proveedores')} />
        </ModalLittle>
    }
    return (
        <ModalCreateBuyOrderConnect setOpened={setOpened} {...rest} />
    )
}

type ModalCreateBuyOrderAfterPermissionsProps = ModalEditComponentProps & ReduxModalCreateBuyOrderConnector & {}

const ModalCreateBuyOrderAfterPermissions: React.FC<ModalCreateBuyOrderAfterPermissionsProps> = ({ userPermissions, allRowData, workingCenters, suppliers, customers, billingGroups,  ...rest }) => {
    const { t } = useTwinTranslation()
    const workingCenter = getSelectedWorkingCenter()
    const { supplierInfo, customerInfo, createBuy, extraBillingTypesBuy, parseBTOBeforeSubmit, fileInfo, mySupplierInfo, addressFields } = useCreateBuy({ suppliers, customers, BillingGroupId: workingCenter?.BillingGroupId, baseURL: locations.buyOrderSingle })
    const error = checkIfCanCreateQuote(t, workingCenters?.[workingCenter?.id])
    const fields: FormRender<BuyOrderModelTypeExtended> = [
        {
            cols: 1,
            elements: [
                ...supplierInfo,
                ...mySupplierInfo,
                ...extraBillingTypesBuy,
                {
                    name: 'custom_name',
                    label: t('customName', 'Nombre personalizado'),
                    component: 'InputWithLabelMargin',
                },
                {
                    name: 'OrderId',
                    component: 'Custom',
                    render: () => <SearchbarBuySupplierDecider baseURL={locations.buyOrderSingle} getDataURL={'/api/app/order/buy/buyOrder/getAllBuyOrdersComplete'} translations={{ title: t('buyOrder', 'Pedido de compra'), seeText: t('seeBuyOrder', 'Ver pedido de compra'), duplicateText: t('duplicateBuyOrderDots', 'Duplicar pedido...') }} />
                },
                ...customerInfo,
                ...fileInfo,
                {
                    name: 'CurrencyId',
                    component: 'InputHidden',
                    value: workingCenter?.CurrencyId
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: workingCenter?.id
                }
            ]
        },
        ...addressFields,
        {
            cols:1, 
            elements: [
            ],
        },
    ]
    return (
        <LittleModalCreateEditChildrenFirst fields={error ? [] : fields} url={'/api/app/order/buy/buyOrder/createBuyOrder'} imagePath={['tmp']} translations={{
            title: t('newBuyOrder', 'Nuevo pedido'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={!error}  {...{ ...rest, onSubmit: createBuy }} beforeSubmit={parseBTOBeforeSubmit}>
            {error ? <CustomError textError={error} className='mb-10' /> : null}
            {!workingCenters?.[workingCenter?.id]?.dictCounters && !error ? <CustomError className='mb-10'  textError={t('notFoundWorkingCenterCounterAndForceCreate', 'No se han encontrado contadores disponibles. Si decide continuar, se generará uno automáticamente.')} /> : null}
        </LittleModalCreateEditChildrenFirst>)
}

const modalCreateBuyOrderDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
    setSuppliers: (payload: SupplierPayload) => ({ type: 'CHANGE_SUPPLIER', payload }),
    setCustomers: (payload: CustomerPayload) => ({ type: 'CHANGE_CUSTOMER', payload }),
    setBillingGroups: (payload: BillingGroupPayload) => ({ type: 'CHANGE_BILLINGGROUP', payload }),
}
const mapModalCreateBuyOrderConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters, suppliers: state.suppliers, customers: state.customers, billingGroups: state.billingGroups })
const modalCreateBuyOrderConnector = connect(mapModalCreateBuyOrderConnector, modalCreateBuyOrderDispatch)
type ReduxModalCreateBuyOrderConnector = ConnectedProps<typeof modalCreateBuyOrderConnector>

const modalCreateBuyOrderConnectLoading = withLoading(ModalCreateBuyOrderAfterPermissions, [{ fetchUrl: '/api/app/supplier/getAllSuppliers', propName: 'suppliers', setFunctionName: 'setSuppliers' }, { fetchUrl: '/api/app/customer/getAllCustomers', propName: 'customers', setFunctionName: 'setCustomers' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }, { fetchUrl: '/api/app/config/billingGroup/getAllBillingGroupsComplete', propName: 'billingGroups', setFunctionName: 'setBillingGroups'}])
const ModalCreateBuyOrderConnect = modalCreateBuyOrderConnector(modalCreateBuyOrderConnectLoading)


export default ModalCreateBuyOrder